import { JWTToken } from '../models/jwt-token.model';
import { LoginUserPwd } from '../models/loginuserpwd.model';
import { User } from '../models/user.model';
import { BaseService } from './base.service';

class SecurityService extends BaseService {  

      async authenticatedUser(): Promise<User | null> {        
        const API_URL = '/api/authenticated-user';
        try { 
            const response = await fetch(API_URL, {
                                            method: "GET", 
                                            headers: this.getHeaders()
                                        });          
            if (!response.ok) {
                throw new Error(`HTTP status: ${response.status}`);
            }

            
            const data: any = await response.text();
            if(data!=null && data!='') {
                return JSON.parse(data);
            }
            return null;
        } catch (error) {
            console.error('Error : ', error);
            throw error;
        } 
    }

    async authenticate(userPwd:LoginUserPwd): Promise<JWTToken> {        
        const API_URL = '/api/authenticate';
        try {
            const response = await fetch(API_URL, {method: "POST", headers: this.getHeaders(), body: JSON.stringify(userPwd)});          
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
    
            const data: JWTToken = await response.json();
            window.sessionStorage.setItem('auth-token', ''+data.idToken);
            return data;
        } catch (error) {
            console.error('Error : ', error);
            throw error;
        } 
    }
}

export default new SecurityService();